module.exports = __webpack_public_path__ + "static/img/search-icon.e06baca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-icon.png
// module id = 1416
// module chunks = 53